// extracted by mini-css-extract-plugin
export const buttonLinkWrapper = "button-link-module--button-link-wrapper--2q1yi";
export const link = "button-link-module--link--PjiS9";